/**
 * An object representing API configurations for the application.
 *
 * @property {Object} settlement - Configuration for the settlement API.
 * @property {string} settlement.description - A description of the settlement API.
 * @property {string} settlement.BaseUrl - The base URL for the settlement API, sourced from the environment variable `REACT_APP_API_PATH`.
 */
const api = {
  settlement: {
    description: 'marketplace for Kitchen Center',
    BaseUrl: process.env.REACT_APP_API_PATH
  }
}

export default api
